import { AccountInfo } from "@azure/msal-browser";

const WIB_WORKSPACE_ID = process.env.WIB_WORKSPACE_ID;

export function hasRole(user: AccountInfo, role: string) {
  const roles = user?.idTokenClaims?.role as string | string[];

  if (!roles) {
    return false;
  } else if (Array.isArray(roles)) {
    return roles.includes(role);
  } else {
    return roles == role;
  }
}

export function hasAuthorizedClient(user: AccountInfo) {
  const clientName = `wib-js-${WIB_WORKSPACE_ID}`;

  return hasRole(user, `api:${clientName}`);
}
